"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* A field box turned with its page, a quarter turn clockwise at a time (the
 * server turns the page image). Boxes are fractions of the page, so they turn
 * about the centre. */


/* Quarter turns clockwise: 1 is 90°, 2 is 180°, 3 is 90° counterclockwise. */


 const rotateBox = (box, turns) => {
  const { x, y, w, h } = box
  switch (turns) {
    case 1: return { x: 1 - y - h, y: x, w: h, h: w }
    case 2: return { x: 1 - x - w, y: 1 - y - h, w, h }
    case 3: return { x: y, y: 1 - x - w, w: h, h: w }
  }
}; exports.rotateBox = rotateBox
